import { Stack, styled } from '@mui/material';

export const TableSearchBarRoot = styled(Stack)(({ theme: { spacing, palette } }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  padding: spacing(1, 2),
  borderBottom: '1px solid',
  borderBottomColor: palette.divider,
}));
